function monthname(m) {
  const monthNames = {
    1: "January",
    2: "Febraury",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  try {
    return monthNames[`${parseInt(m, 10)}`];
  } catch (e) {
    return "X";
  }
}
function ShortDate({ date: dstr }) {
  if (dstr) {
    try {
      const parts = dstr.substring(0, 10).split("-");
      return `${parts[2]} ${monthname(parts[1]).substr(0, 3)}${
        parts[0] === `${new Date().getFullYear()}` ? "" : `, ${parts[0]}`
      }`;
    } catch (e) {
      return "";
    }
  }
  return "";
}

export default ShortDate;
